"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var drawer = function drawer(visible) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:fixed;top:0;right:0;box-sizing:border-box;height:100%;width:640px;padding:44px 44px 0;background:#fff;box-shadow:-12px 0 24px 0 rgba(34,47,66,0.1),-1px 0 3px 0 rgba(34,47,66,0.15);transform:translateX(", visible ? 0 : '102%', ");transition:transform .4s ease-in-out;z-index:1001;")
  );
};

var button = function button() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;top:24px;right:24px;")
  );
};

var _default = {
  drawer: drawer,
  button: button
};
exports.default = _default;